module.exports = __webpack_public_path__ + "img/zhu.551182c8.png";